export default __webpack_public_path__ + "assets/images/62cbf352401d905f39bc107e9c82fe6f.svg";